import React from "react";
import { DeviceLog } from "../../types/mppt";

interface RoutersTableProps {
  deviceLogs?: DeviceLog[];
  getSignalQuality: (rssi: number) => { quality: string; color: string };
}

const RoutersTable: React.FC<RoutersTableProps> = ({
  deviceLogs = [],
  getSignalQuality,
}) => {
  // Filter logs that have network information
  const routersWithNetwork = deviceLogs.filter(
    (log) => log.raw_message.network
  );

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        Routers Status
      </h3>
      {routersWithNetwork.length === 0 ? (
        <div className="text-gray-500">No router data available.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
            <thead>
              <tr className="bg-gray-50">
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Device Name
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Status
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Gateway Local IP
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Public IP
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Router MAC
                </th>
                <th className="px-4 py-2 text-left font-medium text-gray-600">
                  Interface
                </th>
              </tr>
            </thead>
            <tbody>
              {routersWithNetwork.map((log) => {
                const network = log.raw_message.network!;

                return (
                  <tr key={log.id} className="border-b">
                    <td className="px-4 py-2">{log.device_name}</td>
                    <td className="px-4 py-2">
                      <span
                        className={
                          log.device_status === "online"
                            ? "text-green-600"
                            : "text-red-600"
                        }
                      >
                        {log.device_status}
                      </span>
                    </td>
                    <td className="px-4 py-2">{network.local_ip}</td>
                    <td className="px-4 py-2">{network.external_ip}</td>
                    <td className="px-4 py-2">{network.router_mac}</td>
                    <td className="px-4 py-2">{network.interface}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RoutersTable;
